var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_142_3",
    "data-name": "Component 142 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 40,
    height: 40,
    rx: 5,
    fill: "#0c66e4",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44514",
    "data-name": "Group 44514",
    transform: "translate(17.13 2.163) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44515",
    "data-name": "Group 44515",
    transform: "translate(1 1.083)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x2: 14,
    transform: "translate(6.501 9.5)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x1: 14,
    transform: "translate(13.5 2.5) rotate(90)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8e25d2cf890a7bb96a006392493a6e6f.svg";
export { ForwardRef as ReactComponent };